<template>
  <v-card>
    <v-card-title class="blue--text">dnd-zone component</v-card-title>
    <v-card-text class="pb-0">
      <p>the 'dnd-zone' component manages the drag and drop event</p>
    </v-card-text>
    <v-card-title class="pb-0">props:</v-card-title>
    <v-card-text class="pb-0">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Name
              </th>
              <th class="text-left">
                Type
              </th>
              <th class="text-left">
                Default
              </th>
              <th class="text-left">
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>transition-duration</td>
              <td>Number</td>
              <td>0.3</td>
              <td>drag and drop transition duration in seconds</td>
            </tr>
            <tr>
              <td>handle-class</td>
              <td>String</td>
              <td>None</td>
              <td>CSS class to limit drag selection to a specific element</td>
            </tr>
            <tr>
              <td>native-scroll</td>
              <td>Boolean</td>
              <td>true</td>
              <td>When set to false, vue-dnd-zone will use a custom scroll controller that allows scrolling while drag and dropping</td>
            </tr>
            <tr>
              <td>validate</td>
              <td>Function</td>
              <td>
                <code>
                  (item, container, zone) => true
                </code>
              </td>
              <td>Validation function with access to all components envolved in the drag and drop action</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-title>events:</v-card-title>
    <v-card-text class="pb-0">
      <p>vue-dnd-zone will emit a 'move' event on any change to the data structure</p>
      <p>the event payload contains the following data:</p>
      <pre>
        <code style="display: block;white-space: pre-wrap">
      from:{
        container:oldContainer,
        index:oldIndex
      },
      to:{
        container:newContainer,
        index:index
      }
        </code>
      </pre>
    </v-card-text>
    <v-card-title class="blue--text">dnd-container component</v-card-title>
    <v-card-text>
      <p>the 'dnd-container' component creates an html element that acts as a container for dnd items </p>
      <p>it also creates a native vue transition-group component to handle the transitions inside it</p>
    </v-card-text>
    <v-card-title>props:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Name
              </th>
              <th class="text-left">
                Type
              </th>
              <th class="text-left">
                Default
              </th>
              <th class="text-left">
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>dnd-model</td>
              <td>Array</td>
              <td>[]</td>
              <td>*** Required, an array of objects serves as the data container</td>
            </tr>
            <tr>
              <td>dnd-id</td>
              <td>String</td>
              <td>null</td>
              <td>*** Required, a unique id for the data model (similar to 'key')</td>
            </tr>
            <tr>
              <td>tag</td>
              <td>String</td>
              <td>div</td>
              <td>tag for the container DOM element</td>
            </tr>
            <tr>
              <td>vertical-search</td>
              <td>Boolean</td>
              <td>false</td>
              <td>Set to true when items are ordered in a column</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-title class="blue--text">dnd-item component</v-card-title>
    <v-card-text>
      <p>the 'dnd-item' component does not create any markup, it serves as a functional wrapper for the draggable element</p>
    </v-card-text>
    <v-card-title>props:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Name
              </th>
              <th class="text-left">
                Type
              </th>
              <th class="text-left">
                Default
              </th>
              <th class="text-left">
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>dnd-model</td>
              <td>Object</td>
              <td>{}</td>
              <td>*** Required, the data Object corresponding to the dragged DOM element</td>
            </tr>
            <tr>
              <td>dnd-id</td>
              <td>String</td>
              <td>null</td>
              <td>*** Required, a unique id for the data model (similar to 'key')</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    name: 'API',
    data: () => ({
    }),
  }
</script>
